import React from 'react';

const Note = () => (
  <div className="ai-bottom-note">
    This summary was created with our BuzzIQ AI technology.
    { ' ' }
    It automatically summarizes and surfaces primary themes to help bring the voice
    { ' ' }
    of the respondent to life and aid reporting diagnostics. Keep in mind this represents
    { ' ' }
    qualitative analysis. Consider reviewing actual responses to increase confidence and/or
    { ' ' }
    make appropriate revisions to this summary.
  </div>
);

export default Note;
